import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  root: {
    // backgroundColor: theme.palette.secondary.type,
    // backgroundColor: theme.palette.secondary.dark,
    // backgroundColor: theme.palette.secondary.light,
  },
  tablePagination: {
    color: theme.palette.text.secondary,
  },
  tablePaginationCaption: {
    color: theme.palette.text.secondary,
  },
  tablePaginationSelectIcon: {
    color: theme.palette.text.secondary,
  },
  tablePaginationSelect: {
    color: theme.palette.text.secondary,
  },
  tablePaginationActions: {
    color: theme.palette.text.secondary,
  },
}));
